import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer } from 'react';

// reducer - state management
import { LOGIN, LOGOUT } from 'store/actions';
import accountReducer from 'store/accountReducer';

// project imports
import Loader from 'ui-component/Loader';
import axios from 'utils/axios';
import { openSnackbar } from 'store/slices/snackbar';

// constant
const initialState = {
    isLoggedIn: false,
    isInitialized: false,
    user: null
};

const setSession = (serviceToken) => {
    if (serviceToken) {
        localStorage.setItem('serviceToken', serviceToken);
        axios.defaults.headers.common.Authorization = `${serviceToken}`;
    } else {
        localStorage.removeItem('serviceToken');
        delete axios.defaults.headers.common.Authorization;
    }
};

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //
const JWTContext = createContext(null);

export const JWTProvider = ({ children }) => {
    const [state, dispatch] = useReducer(accountReducer, initialState);

    const init = async () => {
        try {
            const serviceToken = localStorage.getItem('serviceToken');
            if (serviceToken) {
                setSession(serviceToken);
                const response = await axios.get('/api/profile/retrive');
                dispatch({
                    type: LOGIN,
                    payload: {
                        isLoggedIn: true,
                        isInitialized: true,
                        user: response.data.user
                    }
                });
            } else {
                dispatch({
                    type: LOGOUT
                });
            }
        } catch (err) {
            dispatch(openSnackbar({
                open: true,
                message: err?.code,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: true
            }))
            setSession();
            dispatch({
                type: LOGOUT
            });
        }
    };

    useEffect(() => {
        init();
    }, []);

    const login = async ({ username, password }) => {
        const response = await axios.post('/api/auth/login', { username, password });
        const { token } = response.data;
        setSession(token);
        init();
    };
    const SSOLogin = async ({token}) => {
        
        setSession(token);
        init();
    };

    const logout = () => {
        setSession(null);
        dispatch({ type: LOGOUT });
    };

    const updateSettings = (type, payload) => {
        dispatch({ type, payload })
    };

    if (state.isInitialized !== undefined && !state.isInitialized) {
        return <Loader />;
    }

    return (
        <JWTContext.Provider value={{ ...state, login, SSOLogin, logout, updateSettings }}>{children}</JWTContext.Provider>
    );
};

JWTProvider.propTypes = {
    children: PropTypes.node
};
export {setSession};
export default JWTContext;
